{
    "name": "@wix/document-management-core-converter",
    "version": "0.2.2",
    "devDependencies": {
        "@size-limit/file": "^11.2.0",
        "@wix/document-manager-utils": "^1.0.0",
        "@wix/document-services-types": "^1.0.0",
        "@wix/format-converter-schemas": "^0.0.0",
        "@wix/import-export-utils": "^1.0.0",
        "@wix/wix-immutable-proxy": "^1.0.0",
        "esbuild": "^0.25.1",
        "lodash": "^4.17.21",
        "size-limit": "^11.2.0"
    },
    "exports": {
        ".": {
            "types": "./dist/src/index.d.ts",
            "source": "./src/index.ts",
            "require": "./dist/index.js",
            "import": "./dist/index.mjs",
            "default": "./dist/index.js"
        },
        "./version": {
            "webpack": "./dist/src/utils/version.webpack.js",
            "types": "./dist/src/utils/version.d.ts",
            "source": "./src/utils/version.ts",
            "default": "./dist/src/utils/version.js"
        }
    },
    "files": [
        "dist"
    ],
    "main": "dist/index.js",
    "publishConfig": {
        "versionBumpStrategy": "patch",
        "registry": "https://npm.dev.wixpress.com/"
    },
    "scripts": {
        "build": "yarn run -TB tsc && yarn run -TB tsc --project version-tsconfig.json && node build.mjs && yarn size-limit",
        "clean": "rm -rf dist",
        "lint": "yarn run -TB eslint . --cache --ext=.js,.ts",
        "test": "yarn run -TB jest"
    },
    "sideEffects": false,
    "size-limit": [
        {
            "path": "./dist/index.js",
            "limit": "33KB"
        },
        {
            "path": "./dist/index.mjs",
            "limit": "55KB"
        }
    ],
    "types": "dist/src/index.d.ts",
    "unpkg": true,
    "wix": {
        "artifact": {
            "groupId": "com.wixpress",
            "artifactId": "document-management-core-converter",
            "targets": {
                "static": false,
                "docker": false
            }
        },
        "validations": {
            "postDependenciesBuild": [
                "lint"
            ]
        }
    }
}
